import React from 'react';
import ProjectsComponent from '../components/ProjectsComponent';
import ProjectCard from '../components/ProjectCard';
import { PROJECT_CATEGORIES } from '../utils/categories';

export default function ProjectsPage() {
  const [projectsData, setProjectsData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [showProjectPopup, setShowProjectPopup] = React.useState(false);
  const [projectPopupMode, setProjectPopupMode] = React.useState("create");



  const categorias = PROJECT_CATEGORIES;

  React.useEffect(() => {
    const fetchProjects = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        alert('No estás autenticado. Por favor, inicia sesión.');
        window.location.href = '/';
        return;
      }

      try {
        setLoading(true);
        const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/project/`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const data = await response.json();
        console.log("Los proyectos son en profile page:", data);

        if (!response.ok) {
          alert(data.message || 'Error al obtener los proyectos');
          window.location.href = '/';
          return;
        }
        //Para cada uno de esos proyectos, obtener los owners y meterlo en un array en prohectsData
        const ownersPromises = data.map(project =>
          fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/project/${project._id}/users`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`
            }
          })
            .then(res => res.json())
            .catch(err => {
              console.error(`Error cargando owners para el proyecto ${project._id}:`, err);
              return [];
            })
        );

        const ownersResults = await Promise.all(ownersPromises);
        const projectsWithOwners = data.map((project, index) => ({
          ...project,
          owners: ownersResults[index] || []
        }));
        setProjectsData(projectsWithOwners);
      } catch (error) {
        console.error('Error fetching projects:', error);
        alert('Error al obtener los proyectos');
      }
      finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  return (
    <>
      <ProjectsComponent
        projects={projectsData}
        categorias={categorias}
        loading={loading}
        onCreateProject={() => { setProjectPopupMode("create"); setShowProjectPopup(true); }}
        onJoinProject={() => { setProjectPopupMode("join"); setShowProjectPopup(true); }}
      />
      <ProjectCard
        isOpen={showProjectPopup}
        onClose={() => setShowProjectPopup(false)}
        project={null}
        mode={projectPopupMode}
      />
    </>
  );
}
